import { render } from "./PricingPlans.vue?vue&type=template&id=c816ceba"
import script from "./PricingPlans.vue?vue&type=script&lang=js"
export * from "./PricingPlans.vue?vue&type=script&lang=js"

import "./PricingPlans.vue?vue&type=style&index=0&id=c816ceba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__